// Here r is function that pulls out all the changelog filenames.
function importAll(r: any) {
  const seenLinks = new Set<string>();

  return r.keys().reduce((acc: any[], fileName: string) => {
    // Normalize path to remove "./" or leading slashes
    const normalizedPath = fileName
      .replace(/^(\.\/|pages\/changelog\/)/, "")
      .replace(/\/index\.mdx$/, "");

    // Avoid duplicates
    if (!seenLinks.has(normalizedPath)) {
      seenLinks.add(normalizedPath);
      acc.push({
        link: normalizedPath,
        module: r(fileName).meta,
        content: r(fileName).content,
      });
    }

    return acc;
  }, []);
}

export const posts = importAll(
  require.context("../pages/changelog/", true, /\.mdx$/)
);
